import { SVGProps } from 'react';

export const NotFound = ({ ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    width="300"
    height="300"
    viewBox="0 0 300 300"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      opacity="0.32"
      x="27.2148"
      y="27.2119"
      width="247.934"
      height="247.934"
      rx="123.967"
      fill="#E5E5E5"
    />
    <g opacity="0.8">
      <rect
        x="40.2799"
        y="78.2012"
        width="220.983"
        height="154.203"
        rx="7.33969"
        fill="white"
        stroke="#666666"
        strokeWidth="2.01572"
      />
      <rect
        x="40.2799"
        y="78.2012"
        width="220.983"
        height="17.0644"
        rx="7.33969"
        fill="#E5E5E5"
        stroke="#666666"
        strokeWidth="2.01572"
      />
      <rect
        x="131.696"
        y="121.955"
        width="8.71685"
        height="31.3745"
        rx="4.35843"
        transform="rotate(48.0917 131.696 121.955)"
        fill="#E5E5E5"
        stroke="#666666"
        strokeWidth="2.01572"
      />
      <rect
        x="0.0768747"
        y="1.42326"
        width="8.71685"
        height="31.3745"
        rx="4.35843"
        transform="matrix(-0.66794 0.744215 0.744215 0.66794 170.766 120.948)"
        fill="#E5E5E5"
        stroke="#666666"
        strokeWidth="2.01572"
      />
      <circle cx="131.967" cy="156.544" r="5.96254" fill="#666666" />
      <circle
        cx="151.272"
        cy="187.05"
        r="5.03931"
        fill="#E5E5E5"
        stroke="#666666"
        strokeWidth="2.01572"
      />
      <circle cx="53.5762" cy="86.7343" r="3.57753" fill="#999999" />
      <circle cx="76.234" cy="86.7343" r="3.57753" fill="#999999" />
      <circle cx="64.3069" cy="86.7343" r="3.57753" fill="#999999" />
      <circle cx="171.682" cy="156.544" r="5.96254" fill="#666666" />
      <path
        d="M87.9914 125.419C87.9914 135.995 79.4179 144.569 68.8419 144.569L25.5041 144.569C14.9281 144.569 6.35464 135.995 6.35464 125.419C6.35465 114.844 14.9282 106.27 25.5041 106.27L68.8419 106.27C79.4178 106.27 87.9914 114.844 87.9914 125.419Z"
        fill="white"
        stroke="#666666"
        strokeWidth="2.01572"
      />
      <path
        d="M77.9109 125.417C77.9107 131.54 72.9467 136.503 66.824 136.503L27.5173 136.503C21.3947 136.503 16.4316 131.54 16.4314 125.417C16.4314 119.295 21.3946 114.331 27.5173 114.331L66.824 114.331C72.9469 114.331 77.9109 119.295 77.9109 125.417Z"
        fill="#F2F3F4"
        stroke="#666666"
        strokeWidth="2.01572"
      />
      <rect
        x="202.67"
        y="194.61"
        width="69.5425"
        height="69.5425"
        rx="34.7712"
        fill="#DFDFDF"
      />
      <rect
        x="248.436"
        y="244.274"
        width="7.61581"
        height="38.2988"
        rx="3.80791"
        transform="rotate(-40.0968 248.436 244.274)"
        fill="white"
        stroke="#666666"
        strokeWidth="2.01572"
      />
      <rect
        x="206.702"
        y="191.586"
        width="67.5267"
        height="67.5267"
        rx="33.7634"
        fill="white"
        stroke="#666666"
        strokeWidth="2.01572"
      />
    </g>
  </svg>
);
